export default __webpack_public_path__ + "static/media/sidemenu.a9f46456.png";